import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import Report from './Report';
import ChangePassword from './ChangePassword';
import Settings from './Settings';
import UserManagement from './UserManagement';
import ManageOrganizations from './ManageOrganizations';
import TypeMapping from './TypeMapping';
import RoleProtectedRoute from './RoleProtectedRoute';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      <Header />
      <div className="dashboard-content">
        <Sidebar />
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/migration" element={<MainContent />} />
          <Route path="/report/:migrationId" element={<Report />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/user-management" element={<RoleProtectedRoute allowedRoles={['admin']}><UserManagement /></RoleProtectedRoute>} />
          <Route path="/type-mapping" element={<RoleProtectedRoute allowedRoles={['admin']}><TypeMapping /></RoleProtectedRoute>} />
          <Route path="/manage-organizations" element={<RoleProtectedRoute allowedRoles={['administrator']}><ManageOrganizations /></RoleProtectedRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
